export default __webpack_public_path__ + "static/media/UserRfpReportActive.290395d6.svg";